/**
 * TWA Initialization
 * Handles TWA-specific configurations for immersive mode and theming
 */

// Detect if running in TWA (Trusted Web Activity)
const isRunningInTWA = (): boolean => {
  // Check for TWA-specific user agent or referrer
  const userAgent = navigator.userAgent || "";
  const referrer = document.referrer || "";

  // TWA typically has 'wv' (WebView) in user agent and comes from the app package
  return (
    userAgent.includes("wv") ||
    referrer.includes("android-app://") ||
    // Check if running in standalone mode (could be PWA or TWA)
    window.matchMedia("(display-mode: standalone)").matches
  );
};

// Initialize TWA-specific settings
const initTWA = () => {
  console.log("🎯 Initializing TWA settings...");
  console.log("Running in TWA:", isRunningInTWA());

  // Set initial dark mode (persisted theme applied later by ClientConfigContext)
  document.documentElement.setAttribute("data-mode", "dark");

  // Set black background color to match system bars
  document.documentElement.style.backgroundColor = "#000000";
  document.body.style.backgroundColor = "#000000";

  // Note: Fullscreen API is not needed in TWA
  // TWA already runs in immersive mode when configured correctly in Android
  // Calling requestFullscreen() in TWA can cause issues

  // If running as PWA (not TWA), we could optionally request fullscreen
  // But for simulator use case, this is probably not needed

  // Add event listener for orientation changes
  window.addEventListener("orientationchange", () => {
    console.log("📱 Orientation changed:", window.screen.orientation.type);
  });

  console.log("✅ TWA initialization complete");
};

// Viewport height fix for mobile browsers
const setViewportHeight = () => {
  // Set CSS custom property for accurate viewport height (accounts for browser UI)
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

// Initialize on DOMContentLoaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    initTWA();
    setViewportHeight();
  });
} else {
  // DOM already loaded
  initTWA();
  setViewportHeight();
}

// Update viewport height on resize
window.addEventListener("resize", setViewportHeight);
